export default new class Order {
    constructor() {
        this.sCreateOrderButtonClass = '_create_order_button';
        this.sFieldClass = '_field';
        this.sApiErrorsWrapperClass = '_api_errors_wrapper';
        this.sInvalidClass = '_invalid';
        this.obButton = {};

        this.create();
        this.paymentCard();
    }

    create() {
        $(document).on('click', `.${this.sCreateOrderButtonClass}`, (obEvent) => {
            setTimeout(() => {

                this.obButton = $(obEvent.target);
                const obForm = this.obButton.closest('form');

                if (obForm.hasClass(this.sInvalidClass)) {
                    return;
                }

                let obData = {'orderData': {}};

                if (this.obButton.is(':disabled')) {
                    return;
                }

                this.obButton.attr('disabled', 'disabled');
                $(`.${this.sFieldClass}`).each(function(){
                    obData.orderData[$(this).attr('name')] = $(this).val();
                });

                const self = this;

                oc.request(obEvent.target, 'LVOrderComponent::onOrder', {
                    data: obData,
                    success:function(response){
                        self.obButton.removeAttr('disabled');
                        if(response.invoice_path) {
                            window.location.replace(response.invoice_path);
                        } else {
                            self.showErrors(response.errors);
                        }
                    }
                });
            }, 0);
        });
    }
    
    paymentCard() {
        const cardContainer = $('#cardData');
        $(document).on('change', 'select[name="payment_method"]', (obEvent) => {
                const value = $(obEvent.target).val();
                if (value === 'authorizecim') {
                        cardContainer.css('display', 'block');
                        cardContainer.find("input").attr("required", true).prop('required', true);
                        cardContainer.find("select").attr('required', true).prop('required', true);
                } else {
                        cardContainer.css('display', 'none');
                        cardContainer.find('input').removeAttr('required').prop('required', false);
                        cardContainer.find('select').removeAttr('required').prop('required', false);
                }

        });
    }

    showErrors(obErrors) {
        let obWrapper = $(`.${this.sApiErrorsWrapperClass}`),
            sClosingTag = ',</a>',
            iCount = obErrors.length;

        obWrapper.empty();
        obWrapper.addClass('active');

        for (let i = 0; i < iCount; i++) {
            if (i === obErrors.length - 1) {
                sClosingTag = '</li>';
            }
            obWrapper.append('<li>' + obErrors[i] + sClosingTag )
        }

        obWrapper.show();
    }
}();
